module.exports = __webpack_public_path__ + "img/HQ-Z7020-V2-all.0065ffb3.jpg";